import colors from '../../../_shared/colors';

export default {
  table: `
    tr.row-warning {
      background-color: ${colors.warningLight};
    }
  `
}